import { render, staticRenderFns } from "./PrizeTable.vue?vue&type=template&id=d9ebf012&scoped=true&"
import script from "./PrizeTable.vue?vue&type=script&lang=js&"
export * from "./PrizeTable.vue?vue&type=script&lang=js&"
import style0 from "./PrizeTable.vue?vue&type=style&index=0&id=d9ebf012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ebf012",
  null
  
)

export default component.exports